import { defineStore } from 'pinia';
import Cookies from 'js-cookie';

const CHAT_TAB_COOKIE = 'chat_tab';
const CHAT_DIALOG_ID_COOKIE = 'chat_dialog_id';
const CHAT_MESSAGE_COOKIE = 'chat_message';
const COOKIE_EXPIRES = 365;

const getValueFromCookie = (name, defaultValue) => {
  const value = Cookies.get(name);
  return value !== undefined ? value : defaultValue;
};

export const useChatStore = defineStore('chat', {
  state: () => ({
    tab: getValueFromCookie(CHAT_TAB_COOKIE, 'newDialog'),
    dialogId: getValueFromCookie(CHAT_DIALOG_ID_COOKIE, null),
    chatMessage: getValueFromCookie(CHAT_MESSAGE_COOKIE, ''),
  }),
  actions: {
    saveToCookies() {
      Cookies.set(CHAT_TAB_COOKIE, this.tab, { expires: COOKIE_EXPIRES });

      if (this.dialogId) {
        Cookies.set(CHAT_DIALOG_ID_COOKIE, this.dialogId, {
          expires: COOKIE_EXPIRES,
        });
      } else {
        Cookies.remove(CHAT_DIALOG_ID_COOKIE);
      }

      if (this.chatMessage) {
        Cookies.set(CHAT_MESSAGE_COOKIE, this.chatMessage, {
          expires: COOKIE_EXPIRES,
        });
      } else {
        Cookies.remove(CHAT_MESSAGE_COOKIE);
      }
    },

    setTab(tab: string) {
      this.tab = tab;
      if (tab !== 'dialog') {
        this.dialogId = null;
      }
      this.saveToCookies();
    },

    setDialogId(id: string | null) {
      this.dialogId = id;
      this.saveToCookies();
    },

    setChatMessage(message: string) {
      this.chatMessage = message;
      this.saveToCookies();
    },

    resetState() {
      this.tab = 'newDialog';
      this.dialogId = null;
      this.chatMessage = '';

      Cookies.remove(CHAT_TAB_COOKIE);
      Cookies.remove(CHAT_DIALOG_ID_COOKIE);
      Cookies.remove(CHAT_MESSAGE_COOKIE);
    },

    onNewDialogCreated(dialog: { id: string }) {
      this.chatMessage = '';
      this.dialogId = dialog.id;
      this.tab = 'dialog';
      this.saveToCookies();
    },

    openProactiveSuggestions() {
      this.dialogId = null;
      this.tab = 'proactiveSuggestions';
      this.saveToCookies();
    },

    openProactiveGeofenceRemovals() {
      this.dialogId = null;
      this.tab = 'proactiveGeofenceRemovals';
      this.saveToCookies();
    },

    onDialogSelected(id: string) {
      this.dialogId = id;
      this.chatMessage = '';
      this.tab = 'dialog';
      this.saveToCookies();
    },
  },
});
